import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const MESES_PT_BR = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export const DIAS_SEMANA_ABREV = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export function formatarDataCurta(date) {
  return format(date, "dd/MM/yyyy", { locale: ptBR });
}

export function formatarDataHora(date) {
  return format(date, "dd/MM/yyyy HH:mm", { locale: ptBR });
}

export function formatarDataLonga(date) {
  return format(date, "EEEE, dd 'de' MMMM 'de' yyyy", { locale: ptBR });
}

export function formatarMesAno(ano, mes) {
  return `${MESES_PT_BR[mes - 1]} de ${ano}`;
}

// "Hoje" como "yyyy-MM-dd" no fuso do navegador. Nunca usar toISOString() para isso:
// ele converte para UTC, e no Brasil (UTC-3) depois das 21h já devolve o dia seguinte.
export function hojeISO(agora = new Date()) {
  return format(agora, "yyyy-MM-dd");
}

export function parseDataISO(value) {
  if (!value) return null;
  return typeof value === "string" ? parseISO(value) : value;
}

// Soma (ou subtrai, com delta negativo) meses a um par ano/mês (mês 1-12), normalizando
// o rollover de ano — usado por qualquer navegação mês a mês (Calendário, filtro de
// período de Recebíveis) para não duplicar a lógica de "mês 13 vira janeiro do ano
// seguinte" em cada feature.
export function adicionarMeses(ano, mes, delta) {
  const data = new Date(ano, mes - 1 + delta, 1);
  return { ano: data.getFullYear(), mes: data.getMonth() + 1 };
}

// Converte "dd/MM/yyyy" (formato de exibição usado pelo backend em LinhaPlantaoDTO.data)
// para "yyyy-MM-dd" (formato aceito por <input type="date">) — usado ao pré-preencher um
// formulário de edição a partir de uma linha já formatada para exibição.
export function paraISOaPartirDeExibicao(dataExibicao) {
  const [dia, mes, ano] = dataExibicao.split("/");
  return `${ano}-${mes}-${dia}`;
}
